import { useQuery } from 'react-query';
import { getBlobsAPI } from '@myme/api';
import { getAllBlobs } from '@myme/logic';
import { DraggableBlob, Pagination } from '@myme/utils';
import { v4 as uuidv4 } from 'uuid';
import { getPageValueForPaginationStartingFromOne } from 'src/hooks';

export const useGetMappedBlobs = (pagination: Pagination, search: string) => {
  const blobsFromQuery = useQuery([...getBlobsAPI.cacheKeys, pagination.page, search], async () => {
    const res = await getAllBlobs(
      { ...pagination, page: getPageValueForPaginationStartingFromOne(pagination.page) },
      search
    );
    const mappedBlobs: DraggableBlob[] = res.data.rows.map(singleBlob => ({
      ...singleBlob,
      dragId: uuidv4()
    }));

    return {
      rows: mappedBlobs,
      total: res.data.total
    };
  });
  const blobs = blobsFromQuery.data?.rows || [];
  const areBlobsLoading = blobsFromQuery.isLoading;

  return { blobs, areBlobsLoading, blobsTotal: blobsFromQuery.data?.total ?? 0 };
};
